import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';

@Component({
  selector: 'app-referance-center-lsit',
  templateUrl: './../../../templates/forms/modals/referance-center-list.html',
})
export class ReferanceCenterListComponent implements OnInit {

  @Input()
  modalShow: boolean = true;
  
  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;
  refList:any[] = [];
  searchFields:any[] = ['REF_NO','REF_NAME'];
  public searchString;
  
  constructor(private dataService: CommonService,
    public langService: LangService) { }

  ngOnInit() {
    this.dataService.getRefNames().subscribe(arg => {
        this.refList = arg.body;
    });
  }

}
